import Head from 'next/head';
import Collapse from '@/components/Collapse';

const AccordionPage: React.FC = () => {
  return (
    <>
      <Head>
        <title>Collapse</title>
      </Head>

      <Collapse />
    </>
  );
};

export default AccordionPage;
